import * as React from 'react';

function SvgIconCircleQuestion(props) {
  return (
    <svg width={14} height={14} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g clipPath="url(#icon-circle-question_svg__a)" fill="#000" fillOpacity={0.85}>
        <path d="M7 .875a6.125 6.125 0 100 12.25A6.125 6.125 0 007 .876zm0 11.21a5.087 5.087 0 11.002-10.173A5.087 5.087 0 017 12.086z" />
        <path d="M8.526 4.33A2.305 2.305 0 007 3.772c-.574 0-1.116.198-1.526.556a1.864 1.864 0 00-.662 1.413v.104c0 .06.05.109.11.109h.656c.06 0 .11-.05.11-.11v-.103c0-.603.589-1.094 1.312-1.094.723 0 1.312.49 1.312 1.094 0 .425-.3.815-.767.994a1.528 1.528 0 00-.984 1.446v.294c0 .06.05.11.11.11h.656a.11.11 0 00.109-.11v-.31a.66.66 0 01.422-.613c.807-.31 1.328-1.021 1.328-1.811a1.858 1.858 0 00-.66-1.413zm-2.073 5.677a.547.547 0 101.094 0 .547.547 0 00-1.094 0z" />
      </g>
      <defs>
        <clipPath id="icon-circle-question_svg__a">
          <path fill="#fff" d="M0 0h14v14H0z" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default SvgIconCircleQuestion;
